import { Box, Button, Card, Container, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { News } from '../config/types';
import axios from 'axios';

export const host = process.env.REACT_APP_TVAPP_SERVER_HOST;
const NewsDetail = () => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    let newsId = searchParams.get("id")



    let id = 1;

    if (newsId !== null) {
        id = Number(newsId);
    }

    console.log("newsId", newsId)
    const [news, setNews] = useState<News>();

    const getNewsDetail = async (newsId: number) => {
        const url = host + '/data/api.tvAppOpenApi/getNewsDetail';
        const data = new URLSearchParams();
        data.append('id', newsId.toString());

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        try {
            const response = await axios.post(url, data, config);

            const responseData = response.data;
            if (responseData.code === 1) {
                setNews(responseData.data);




            }
            console.log(response.data);
        } catch (error) {
            console.error(error);
        }


        // const url = 'http://admin.hrhmt.btcsoft.io/data/api.tvAppOpenApi/getNewsDetail';


        // const data = { id: newsId };

        // try {
        //     const response = await fetch(url, {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json; charset=utf-8'
        //         },
        //         body: JSON.stringify(data)
        //     });

        //     if (!response.ok) {
        //         throw new Error('Network response was not ok');
        //     }

        //     const responseData = await response.json();


        //     if (responseData.code === 1) {
        //         setNews(responseData.data)
        //     }

        //     console.log(responseData);
        // } catch (error) {
        //     console.error(error);
        // }
    }

    const backHome = () => {
        window.history.back();
    }

    useEffect(() => {
        getNewsDetail(id);
    }, [])



    useEffect(() => {
        const element = document.getElementById('newscontent');
        if (typeof (element) !== 'undefined' && element !== null && typeof (news) !== 'undefined' && news !== null) {
            element.innerHTML = news.content;
        }
    }, [news])

    return <Layout>
        <div className="w3l-innerblock">
        </div>
        <div className="news-detail">
            <Container>
                <>
                    {typeof (news) !== 'undefined' ? (
                        <Box className='news'>
                            <h4>{news.name}</h4>
                            <div className='ctime'>
                                {news.create_at}
                            </div>
                            <div className='content-box'>
                                <div className='cover'>
                                    <img src={news.cover} alt={news.name} />
                                </div>
                                <div className='content' id="newscontent">
                                </div>
                                <p style={{ textAlign: 'center', paddingBottom:'60px' }}>
                                    <button className="btn btn-style btn-outline-primary mt-lg-0 mt-md-5 mt-4" onClick={backHome}><span className="fa fa-arrow-left mr-3"></span>返回</button>
                                </p>

                            </div>
                        </Box>
                    ) : null}
                </>

            </Container>
        </div>
    </Layout>
}
export default NewsDetail;